import { render } from "./AdDocViewTransactionsAcceptRefuseButtons.vue?vue&type=template&id=5be44a57&ts=true"
import script from "./AdDocViewTransactionsAcceptRefuseButtons.vue?vue&type=script&lang=ts"
export * from "./AdDocViewTransactionsAcceptRefuseButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__